export const data = () => ({
  isDebug: true,
  loading: false,
  escrowID: 0,
  styles: {
    filterButton: {
      float: 'right',
      marginTop: '4px'
    }
  }
})
